const codes = {
  '754': 'dz',
  '755': 'ao',
  '756': 'am',
  '757': 'bj',
  '758': 'bw',
  '759': 'bf',
  '760': 'bi',
  '2025': 'cm',
  '761': 'cv',
  '762': 'cf',
  '763': 'td',
  '764': 'cg',
  '765': 'cd',
  '767': 'dj',
  '768': 'eg',
  '769': 'gq',
  '770': 'er',
  '771': 'et',
  '772': 'ga',
  '773': 'gm',
  '774': 'gh',
  '775': 'gw',
  '2026': 'ci',
  '777': 'ke',
  '778': 'ls',
  '779': 'lr',
  '780': 'ly',
  '781': 'mg',
  '782': 'mw',
  '783': 'ml',
  '784': 'mr',
  '785': 'mu',
  '786': 'ma',
  '787': 'mz',
  '788': 'na',
  '789': 'ne',
  '790': 'ng',
  '791': 're',
  '792': 'rw',
  '793': 'sn',
  '794': 'sc',
  '795': 'sl',
  '796': 'so',
  '797': 'za',
  '2631': 'sd',
  '2632': 'ss',
  '798': 'sz',
  '799': 'tz',
  '800': 'tg',
  '801': 'tn',
  '802': 'ug',
  '803': 'eh',
  '804': 'zm',
  '805': 'zw',
  '807': 'af',
  '808': 'bh',
  '809': 'bd',
  '810': 'bt',
  '811': 'bn',
  '812': 'kh',
  '814': 'cn',
  '815': 'tl',
  '816': 'in',
  '817': 'id',
  '818': 'ir',
  '819': 'iq',
  '820': 'il',
  '821': 'jp',
  '1481': 'jo',
  '822': 'kz',
  '823': 'kr',
  '824': 'kw',
  '825': 'kg',
  '826': 'la',
  '827': 'lb',
  '828': 'mo',
  '829': 'my',
  '830': 'mv',
  '1999': 'me',
  '831': 'mn',
  '832': 'mm',
  '833': 'np',
  '834': 'om',
  '835': 'pk',
  '1934': 'ps',
  '836': 'ph',
  '837': 'qa',
  '838': 'sa',
  '839': 'sg',
  '840': 'lk',
  '841': 'sy',
  '842': 'tw',
  '843': 'tj',
  '844': 'th',
  '845': 'tm',
  '846': 'ae',
  '847': 'uz',
  '848': 'vn',
  '2538': 'vn',
  '849': 'ye',
  '2566': 'ag',
  '2567': 'aw',
  '2569': 'bb',
  '2559': 'bz',
  '2560': 'cr',
  '2572': 'cu',
  '2573': 'cw',
  '2579': 'dm',
  '2574': 'do',
  '2590': 'bq',
  '2561': 'sv',
  '2575': 'gd',
  '2576': 'gp',
  '2562': 'gt',
  '2578': 'ht',
  '2563': 'hn',
  '2581': 'mq',
  '2582': 'ms',
  '2564': 'ni',
  '2565': 'pa',
  '2584': 'kn',
  '2583': 'lc',
  '2577': 'mf',
  '2585': 'pm',
  '2586': 'vc',
  '2587': 'sx',
  '2588': 'tt',
  '2589': 'tc',
  '1882': 'al',
  '851': 'at',
  '852': 'az',
  '853': 'by',
  '854': 'be',
  '855': 'ba',
  '856': 'bg',
  '857': 'hr',
  '858': 'cy',
  '859': 'cz',
  '860': 'dk',
  '861': 'ee',
  '862': 'fi',
  '863': 'fr',
  '864': 'ge',
  '865': 'de',
  '866': 'gr',
  '867': 'hu',
  '868': 'is',
  '2086': 'ie',
  '869': 'it',
  '870': 'xk',
  '871': 'lv',
  '872': 'lt',
  '2076': 'lu',
  '874': 'mt',
  '875': 'md',
  '876': 'mc',
  '2767': 'me',
  '877': 'nl',
  '873': 'mk',
  '878': 'no',
  '879': 'pl',
  '880': 'pt',
  '881': 'ro',
  '882': 'ru',
  '883': 'rs',
  '884': 'sk',
  '885': 'si',
  '886': 'es',
  '887': 'se',
  '888': 'ch',
  '889': 'tr',
  '890': 'ua',
  '891': 'gb',
  '893': 'bs',
  '895': 'bm',
  '896': 'ca',
  '897': 'ky',
  '908': 'jm',
  '910': 'mx',
  '2591': 'pr',
  '915': 'us',
  '917': 'ar',
  '918': 'bo',
  '919': 'br',
  '920': 'cl',
  '1480': 'co',
  '2062': 'ec',
  '921': 'gf',
  '922': 'gy',
  '923': 'py',
  '924': 'pe',
  '925': 'sr',
  '926': 'uy',
  '927': 've',
  '929': 'au',
  '930': 'pf',
  '931': 'nr',
  '932': 'nc',
  '933': 'nz',
  '934': 'pg',
  '935': 'xx',
};

export default codes;
